import React from 'react'
import PropTypes from 'prop-types'

import MuiButton from '@material-ui/core/Button'
import Cancel from '@material-ui/icons/Cancel'

const CancelButton = (props) => {
  return (
    <MuiButton
      color='secondary'
      onClick={props.onClick}
    >
      <Cancel /> &nbsp;Cancel
    </MuiButton>
  )
}

CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

CancelButton.defaultProps = {}

export default CancelButton
